import axios from "axios";
import { store } from "../store";
import config from "../config";
import authHeader from "./auth-header";

const API_URL = config.API_URL;

const updateXeroKey = () => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const formData = new FormData();
  
  // Append the required fields
  // formData.append("client_id", values.xero_client_id);
  // formData.append("client_secret", values.xero_secret_id);
  formData.append("salon_id", auth.user.salon_id);
  
  const action = "afterlogin/xero/connect";
  formData.append("auth_key", auth_key);
  formData.append("action", action);
  
  return axios.post(API_URL + action, formData, { 
    headers: authHeader({ contentType: "multipart/form-data" }) 
  });
};

const handleCallback = (code) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const formData = new FormData();
  
  formData.append("code", code);
  formData.append("auth_key", auth_key);
  
  const action = "afterlogin/xero/callback";
  return axios.post(API_URL + action, formData, { 
    headers: authHeader({ contentType: "multipart/form-data" }) 
  });
};

const XeroService = {
  updateXeroKey,
  handleCallback,
};

export default XeroService; 